import React from 'react';
import { PriceDisplay } from '../utils/currency';
import { trackAddToCart } from './MetaPixel';
export const Hero = () => {
  const handleBuyClick = (e: React.MouseEvent) => {
    trackAddToCart();
  };
  return <section className="py-12 px-4 sm:px-6 md:px-8 max-w-7xl mx-auto" data-id="element-187">
      <div className="flex flex-col md:flex-row items-center" data-id="element-188">
        <div className="md:w-1/2 mb-8 md:mb-0 text-center" data-id="element-189">
          <h1 className="font-sans text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-[#0C1B2A] leading-tight mb-4" data-id="element-190">
            <span className="block text-center mb-3 bg-gradient-to-r from-[#D4AF37] to-[#8B7D29] bg-clip-text text-transparent" data-id="element-191">
              Guía Contra el Mal de Ojo
            </span>
            <span className="block text-center mt-2" data-id="element-192">
              Limpia tu energía en 7 días y protege a tu familia con rituales
              ancestrales
            </span>
          </h1>
          <p className="text-lg mb-6 text-[#555555] mx-auto max-w-lg" data-id="element-193">
            Método simple, en casa, con pasos diarios. Sin amuletos vacíos ni
            promesas vagas.
          </p>
          <div className="mb-2" data-id="element-194">
            <a href="https://pay.hotmart.com/Y101890168S?checkoutMode=10" className="btn-purchase inline-block bg-[#0C1B2A] hover:bg-[#1A2A3A] text-white font-bold py-3 px-8 rounded-lg shadow-lg transition-colors duration-300 mb-2 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#0C1B2A]" aria-label="Descargar ahora por once dólares con noventa y nueve centavos" onClick={handleBuyClick} data-id="element-195">
              Descargar ahora — $11.99
            </a>
            <PriceDisplay data-id="element-196" />
          </div>
          <div className="flex flex-wrap items-center justify-center text-sm text-[#666666] mt-4" data-id="element-197">
            <span className="flex items-center mr-4 mb-2" data-id="element-198">
              <svg className="w-4 h-4 text-[#D4AF37] mr-1" viewBox="0 0 20 20" fill="currentColor" data-id="element-199">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-200" />
              </svg>
              + Lectoras satisfechas
            </span>
            <span className="flex items-center mr-4 mb-2" data-id="element-201">
              <svg className="w-4 h-4 text-[#D4AF37] mr-1" viewBox="0 0 20 20" fill="currentColor" data-id="element-202">
                <path fillRule="evenodd" d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 0h8v12H6V4z" clipRule="evenodd" data-id="element-203" />
              </svg>
              Formato PDF
            </span>
            <span className="flex items-center mb-2" data-id="element-204">
              <svg className="w-4 h-4 text-[#D4AF37] mr-1" viewBox="0 0 20 20" fill="currentColor" data-id="element-205">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v3.586L7.707 9.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 10.586V7z" clipRule="evenodd" data-id="element-206" />
              </svg>
              Acceso inmediato
            </span>
          </div>
        </div>
        <div className="md:w-1/2 md:pl-8" data-id="element-207">
          <div className="relative" data-id="element-208">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cnXT5L7fLgjUhX2VoBc1J8/Diseno_sin_titulo_%281%29.png" alt="Portada del ebook Guía Contra el Mal de Ojo" className="rounded-lg shadow-2xl mx-auto max-w-full h-auto" width="400" height="500" loading="eager" fetchpriority="high" data-id="element-209" />
            <div className="absolute -bottom-4 -right-4 bg-white rounded-full p-3 shadow-lg" data-id="element-210">
              <svg className="w-8 h-8 text-[#D4AF37]" fill="currentColor" viewBox="0 0 20 20" data-id="element-211">
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-212" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </section>;
};